<template>
  <va-edit-layout>
    <department-form :id="id" :title="title" :item="item"></department-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
